import { Button } from "@material-ui/core";
import SystemUpdateAltIcon from "@material-ui/icons/SystemUpdateAlt";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";

type Props = {
  title: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const useStyles = makeThemedStyles("ExportDashboardButton", (theme) => ({
  root: {
    textAlign: "center",
    borderRadius: "30px",
    borderWidth: "0px",
    fontSize: "1.6em",
    fontWeight: 500,
    lineHeight: "15px",
    padding: "0px 20px 0px 20px",
    cursor: "pointer",
    height: "44px",
    textTransform: "none",
    background: "white",
    color: "rgba(76,81,87, 0.8)",
    marginInlineEnd: "16px",
    "&:hover": {
      backgroundColor: "#fff",
    },
    "& .MuiButton-endIcon": {
      marginInlineStart: "8px",
    },
  },
}));

const ExportButton = (props: Props) => {
  const classes = useStyles();

  return (
    <Button
      classes={classes}
      onClick={props.onClick}
      endIcon={<SystemUpdateAltIcon />}
    >
      {props.title}
    </Button>
  );
};

export default ExportButton;
